import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { DefaultProperty, EPropertyOrigin } from '../../data/Constants';
import { ApiKeyApi } from '../../api/ApiKeyApi';

import type { IApiKey, IApiKeyState } from '../../../types';
import type { IAPIKeyRequest } from '../../../types/IApiTypes';

//To get paginated ApiKeys data
export const getApiKeys = createAsyncThunk(
  'administration/getApiKeys',
  async (action: IAPIKeyRequest, thunkAPI) => {
    return ApiKeyApi.getApiKeys(action, thunkAPI.dispatch);
  }
);

//To create api key
export const createApiKey = createAsyncThunk(
  'apikeys/createApiKey',
  async (action: { request: IApiKey }, thunkAPI) => {
    return ApiKeyApi.createApiKey(action, thunkAPI.dispatch);
  }
);

//To update api key
export const updateApiKey = createAsyncThunk(
  'apikeys/updateApiKey',
  async (action: { request: IApiKey }, thunkAPI) => {
    return ApiKeyApi.updateApiKey(action, thunkAPI.dispatch);
  }
);

//To delete apikey
export const deleteApiKeys = createAsyncThunk(
  'apikeys/deleteApiKeys',
  async (action: { request: { ids: string[] } }, thunkAPI) => {
    return ApiKeyApi.deleteApiKeys(action, thunkAPI.dispatch);
  }
);

//To get the service users for apikey management tab
export const getServiceUsers = createAsyncThunk(
  'apikeys/getServiceUsers',
  async (_action, thunkAPI) => {
    return ApiKeyApi.getServiceUsers(thunkAPI.dispatch);
  }
);

//To get the configit property list for apikey management tab
export const getConfigitPropertyList = createAsyncThunk(
  'apikeys/getConfigitPropertyList',
  async (_action, thunkAPI) => {
    return ApiKeyApi.getConfigitPropertyList(thunkAPI.dispatch);
  }
);

//To get the pdm property list for apikey management tab
export const getPdmPropertyList = createAsyncThunk(
  'apikeys/getPdmPropertyList',
  async (_action, thunkAPI) => {
    return ApiKeyApi.getPdmPropertyList(thunkAPI.dispatch);
  }
);

//To get the privileges
export const getPrivileges = createAsyncThunk(
  'apikeys/getPrivileges',
  async (_action, thunkAPI) => {
    return ApiKeyApi.getPrivileges(thunkAPI.dispatch);
  }
);

const initialState: IApiKeyState = {
  serviceUsers: [],
  properties: {
    configit: [],
    pdm: [],
  },
  privileges: [],
};

const apikeySlice = createSlice({
  name: 'apikeys',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getServiceUsers.fulfilled, (state, action) => {
        if (action.payload && 'data' in action.payload) {
          state.serviceUsers = action.payload.data;
        }
      })
      .addCase(getConfigitPropertyList.fulfilled, (state, action) => {
        if (action.payload && 'data' in action.payload) {
          state.properties.configit = [...DefaultProperty, ...action.payload.data];
          state.properties.configit = state.properties.configit.filter((prop) => prop.code !== '');
        }
      })
      .addCase(getPdmPropertyList.fulfilled, (state, action) => {
        if (action.payload && 'data' in action.payload) {
          state.properties.pdm = [...DefaultProperty, ...action.payload.data];
          state.properties.pdm = state.properties.pdm.filter(
            (prop) =>
              (prop.code !== '' && prop.origin === EPropertyOrigin.Pdm && prop.isActive) ||
              prop.code === DefaultProperty[0].code
          );
        }
      })
      .addCase(getPrivileges.fulfilled, (state, action) => {
        if (action.payload && 'data' in action.payload) {
          state.privileges = action.payload.data;
        }
      });
  },
});

export default apikeySlice.reducer;
